/* eslint-disable react/prop-types */
import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import * as dayjs from 'dayjs';
import '../../App.scss';
import { connect } from 'react-redux';
import { ThemeContext } from 'styled-components';
import { useHistory } from 'react-router-dom';
import Container from '../../atoms/Grid/Container';
import {
  HomePageBackground,
  HomePageOverlay,
  HomePageContainer,
  MaxWidthDiv,
  HomePageTitleContainer,
  HomePageSubtitleContainer,
  ButtonMainRedContainer,
  SeachBarContainer,
  IconFilterMobile,
} from './index.style';
import Button from '../../atoms/Button';
import Typography from '../../atoms/Typography';
import TextInput from '../../atoms/TextInput';
import { colorsNameKey } from '../../const/theme.const';
import ScrollToTopButton from '../../components/ScrollToTopButton';
import ICONS_TYPE from '../../atoms/Icon/index.enum';
import { TRANSLATION_KEYS } from '../../i18n/index.enum';
import Row from '../../atoms/Grid/Row';
import Col from '../../atoms/Grid/Col';
import InputSelect from '../../atoms/InputSelect';
import Modal from '../../components/Modal';
import Icon from '../../atoms/Icon';
import ModalBodyHomepage from '../../components/Modal/modalBody/ModalBodyHomepage';
import { ROUTES_URL } from '../../components/RouterContainer/index.routes';
import {
  GET_ALL_MODEL_CAR,
  GET_ALL_COLOR_EXT_CAR,
  GET_ALL_CERTIFICATION_LIGHT_HOUSE,
} from '../../redux/actions/homepage';
import { selectFilter } from './index.const';
import { windowSize } from '../../ui/theme/device';

const Homepage = ({
  models,
  colorsExt,
  vehicleList,
  getAllModelCar,
  getAllColorExtCar,
  getAllCertificationLightHouse,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [modalShow, setShoWModal] = useState(false);

  const [yearProduction, setYearProduction] = useState();

  const [search, setSearch] = useState();

  const [initialfilters, setInitialfilters] = useState(selectFilter(t));
  const [filters, setFilters] = useState(selectFilter(t));
  const [activeFilters, setActiveFilters] = useState({});

  const callAllCertificationWithFilters = (hasToReset) => {
    history.push(ROUTES_URL.car_list(), activeFilters);
  };

  useEffect(() => {
    getAllModelCar();
    getAllColorExtCar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAllModelCar, getAllColorExtCar]);

  useEffect(() => {
    setFilters((state) => [
      ...state.map((filter) => (filter.id === 'model'
        ? {
          ...filter,
          option: [
            ...filter.option,
            ...models.map((model) => ({
              label: model,
              value: model,
              selected: false,
              disabled: false,
            })),
          ],
        }
        : { ...filter })),
    ]);
  }, [models]);

  useEffect(() => {
    if (colorsExt.length > 0) {
      setFilters((state) => [
        ...state.map((filter) => (filter.id === 'external_color'
          ? {
            ...filter,
            option: [
              ...filter.option,
              ...colorsExt.map((color) => ({
                label: color,
                value: color,
                selected: false,
                disabled: false,
              })),
            ],
          }
          : { ...filter })),
      ]);
    }
  }, [colorsExt]);

  useEffect(() => {
    setInitialfilters((state) => [
      ...state.map((filter) => (filter.id === 'modello'
        ? {
          ...filter,
          option: [
            ...filter.option,
            ...models.map((model) => ({
              label: model,
              value: model,
              selected: false,
              disabled: false,
            })),
          ],
        }
        : filter)),
    ]);
  }, [models]);

  useEffect(() => {
    if (Object.keys(activeFilters).length > 0) {
      // activeFilters = nazionalita: italiana"
      setFilters((state) => [
        ...state.map((filterElement) => ({
          ...filterElement,
          // activeFilters: {colore_interni : "rosso", stato_certificazione: "b"}
          // option  activeFilters[colore_interni]
          // controlla se stai iterando l'elemento presente
          // in activeFilters, nel caso cambi il valore di selected
          option: activeFilters[filterElement.id] // activeFilters.colore_interni
            ? [
              ...filterElement.option.map((option) => ({
                ...option,
                selected: activeFilters[filterElement.id] === option.value,
              })),
            ]
            : [...filterElement.option],
        })),
      ]);
    } else {
      setFilters(initialfilters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeFilters]);

  const { size } = windowSize();

  const themeContext = useContext(ThemeContext);

  return (
    <>
      {themeContext.device.windowScroolToTop().scroll > (window.innerHeight / 2) ? (
        <ScrollToTopButton />
      ) : null}
      <HomePageBackground>
        <HomePageOverlay />
        <Container>
          <HomePageContainer>
            {size === 'S' ? (
              <IconFilterMobile alert={Object.keys(activeFilters).length > 0}>
                <Icon
                  icon={Icon.ICONS_TYPE.SETTTINGS}
                  size={18}
                  onClick={() => setShoWModal((state) => !state)}
                />
              </IconFilterMobile>
            ) : null}
            <HomePageTitleContainer>
              <Typography
                tag="h1"
                type={Typography.TYPES.DSP_2}
                color={colorsNameKey.BLACK_90}
              >
                {t(TRANSLATION_KEYS.HOMEPAGE.TITLE)}
              </Typography>
            </HomePageTitleContainer>
            <HomePageSubtitleContainer>
              <MaxWidthDiv maxWidth="80%">
                <Typography
                  tag="p"
                  type={Typography.TYPES.BODY}
                  color={colorsNameKey.BLACK_90}
                >
                  {t(TRANSLATION_KEYS.HOMEPAGE.SUBTITLE)}
                </Typography>
              </MaxWidthDiv>
            </HomePageSubtitleContainer>
            {size !== 'S' ? (
              <>
                <SeachBarContainer>
                  <Row>
                    <Col xs="12" sm="12" md="12" xl="3" lg="3">
                      <TextInput
                        margin="20px 0px 0px 0px"
                        id="searcHome"
                        value={activeFilters.vin}
                        onChange={({ target: { value } }) => {
                          setActiveFilters((state) => ({
                            ...state,
                            vin: value,
                          }));
                        }}
                        placeholder={t(
                          TRANSLATION_KEYS.HOMEPAGE.INPUT_SEARCH_FILTER,
                        )}
                        icon={ICONS_TYPE.SEARCH}
                        type={TextInput.TYPES.SEARCH.name}
                      />
                    </Col>
                    {filters.map((element, index) => (
                      <Col
                        xs="12"
                        sm="12"
                        md="12"
                        xl="3"
                        lg="3"
                        key={element.id}
                      >
                        <InputSelect
                          id={element.id}
                          disabled={element.disabled}
                          margin="20px 0px 0px 0px"
                          icon={ICONS_TYPE.CHEVRON_DOWN}
                          selectOption={element.option}
                          onChange={({ target: { value } }) => {
                            setActiveFilters((state) => ({
                              ...state,
                              [element.id]: value,
                            }));
                          }}
                        />
                      </Col>
                    ))}
                    <Col xs="12" sm="12" md="12" xl="3" lg="3">
                      <ButtonMainRedContainer>
                        <Button
                          type={Button.TYPES.MAIN_RED}
                          onClick={() => callAllCertificationWithFilters(true)}
                        >
                          {t(TRANSLATION_KEYS.HOMEPAGE.BUTTON_SEARCH)}
                        </Button>
                      </ButtonMainRedContainer>
                    </Col>
                  </Row>
                </SeachBarContainer>
              </>
            ) : null}

          </HomePageContainer>
          {size === 'S' ? (
            <Modal
              active={modalShow}
              fullScreen
              padding="0 25px"
              close={() => setShoWModal(false)}
            >
              <ModalBodyHomepage
                filter={filters}
                activeFilters={activeFilters}
                onFiltersChange={(newActiveFilters) => {
                  setActiveFilters(newActiveFilters);
                }}
                onSubmit={() => {
                  callAllCertificationWithFilters(true);
                  setShoWModal(false);
                }}
                minimal
                yearProduction={yearProduction}
                onYearFilterChange={setYearProduction}
                searchText={search}
                onSearchChange={setSearch}
              />
            </Modal>
          ) : null}
        </Container>
      </HomePageBackground>
    </>
  );
};

export default connect(
  // eslint-disable-next-line camelcase
  ({ homepage: { models, colorsExt, vehicleList } }) => ({
    models,
    colorsExt,
    vehicleList,
  }),
  (dispatch) => ({
    getAllModelCar: () => dispatch({ type: GET_ALL_MODEL_CAR._REQUEST }),
    getAllColorExtCar: () => dispatch({ type: GET_ALL_COLOR_EXT_CAR._REQUEST }),
    getAllCertificationLightHouse: (payload, reset) => dispatch({
      type: GET_ALL_CERTIFICATION_LIGHT_HOUSE._REQUEST,
      payload,
      reset,
    }),
  }),
)(Homepage);
